var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdleicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-iij058",
    focusable: "false",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "#F6F9FC",
    stroke: "#FFC259",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4527_1380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33344 9.25005C6.4851 9.40172 6.53177 9.61755 6.47927 9.82172C6.2751 10.6151 6.26927 11.4959 6.5376 12.3767C7.05094 14.0742 8.54427 15.3517 10.2943 15.6142C13.5143 16.0867 16.2384 13.2459 15.5618 10.0026C15.1826 8.17672 13.6776 6.73005 11.8459 6.40922C11.1401 6.28672 10.4576 6.32172 9.8276 6.48505C9.62344 6.53755 9.40177 6.48505 9.25594 6.33922C8.92927 6.01255 9.0926 5.47005 9.5301 5.35339C10.3876 5.13172 11.3151 5.09672 12.2718 5.30089C14.5934 5.80255 16.4076 7.73922 16.7634 10.0842C17.3701 14.0567 13.9518 17.4226 9.97344 16.7459C7.63427 16.3434 5.73844 14.4942 5.28344 12.1667C5.1026 11.2392 5.14344 10.3467 5.35344 9.52422C5.4701 9.08672 6.0126 8.92922 6.33344 9.25005ZM8.08344 7.20839C8.08344 7.69255 7.6926 8.08339 7.20844 8.08339C6.72427 8.08339 6.33344 7.69255 6.33344 7.20839C6.33344 6.72422 6.72427 6.33339 7.20844 6.33339C7.6926 6.33339 8.08344 6.72422 8.08344 7.20839ZM11.0001 7.50005C9.06927 7.50005 7.5001 9.06922 7.5001 11.0001C7.5001 12.9309 9.06927 14.5001 11.0001 14.5001C12.9309 14.5001 14.5001 12.9309 14.5001 11.0001C14.5001 9.06922 12.9309 7.50005 11.0001 7.50005ZM9.83344 12.7501C9.5126 12.7501 9.2501 12.4876 9.2501 12.1667V9.83339C9.2501 9.51255 9.5126 9.25005 9.83344 9.25005C10.1543 9.25005 10.4168 9.51255 10.4168 9.83339V12.1667C10.4168 12.4876 10.1543 12.7501 9.83344 12.7501ZM12.1668 12.7501C11.8459 12.7501 11.5834 12.4876 11.5834 12.1667V9.83339C11.5834 9.51255 11.8459 9.25005 12.1668 9.25005C12.4876 9.25005 12.7501 9.51255 12.7501 9.83339V12.1667C12.7501 12.4876 12.4876 12.7501 12.1668 12.7501Z",
    fill: "#FFC259"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4527_1380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdleicon);
export default __webpack_public_path__ + "static/media/idleicon.50043e3ba56bb1cc239f28cc7f53a36f.svg";
export { ForwardRef as ReactComponent };